export default class Guest {
  constructor(data) {
    this.host = data?.host;
    this.cypress = data?.cypress;
    this.admin = false;
    this.signedIn = false;
    this.sessionFetchedAt = null;
    // The roster fragment `Web::GuestSession#as_json` stamps through
    // `Web::TeamContactPayload`, named here because this constructor is a
    // WHITELIST (artemis-human-handoff D8). The signed-out menu renders from
    // the same two keys the signed-in one does. `pulse` deliberately has no
    // line: the guest envelope stamps no capability, and `admin`/`signedIn`
    // above are hardcoded rather than copied for the same reason — whatever
    // payload reaches this constructor, the result is a guest.
    this.teamContacts = data?.teamContacts || [];
    this.teamEmail = data?.teamEmail || null;
    // The upload-cap table (media-economics D10) — a guest sees an upload
    // form's limit before registering. `Web::GuestSession#as_json` does not
    // yet stamp this key (a backend gap, filed as a follow-on), so this reads
    // `undefined` today and falls back to null, exactly as a stale cached
    // signed-in session does: no client-side limit, the server still enforces.
    this.attachmentCaps = data?.attachmentCaps || null;
  }
}
